import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography
} from "@mui/material";
import React from "react";
import {HighlightOff} from "@mui/icons-material";
import { DialogHeader } from "../../../../../../theme";

// region TypeScript Interfaces
interface ProfileValues {
    Id?: string | number;
    Shared?: boolean;
    [key: string]: unknown;
}

interface EnhancedDeleteDialogProps {
    open: boolean;
    onClose: (event?: unknown, reason?: string) => void;
    values: ProfileValues;
    disabled?: boolean;
    deleteFnc: () => void;
}
// endregion

export default function EnhancedDeleteDialog(props: EnhancedDeleteDialogProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {open, onClose, values, disabled, deleteFnc} = props; // These vars are used

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                if (disabled) return;
              }
              onClose(event, reason);
            }}
            maxWidth='sm'
            fullWidth={true}
            slotProps={{
                paper: {
                    style: {
                        borderRadius: "12px"
                    }
                }
            }}>
            <DialogTitle>
                <Grid item container justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item container style={{flex: 0.5, flexDirection: "column"}}>
                        <DialogHeader>
                            Confirm Delete
                        </DialogHeader>
                    </Grid>

                    <IconButton onClick={() => props.onClose()} size="large">
                        <HighlightOff style={{color: "red"}}/>
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent>
                {values.Id && !values.Shared &&
                    <Typography style={{fontSize: "16px"}}>
                        This profile is visible to all users at your company.
                    </Typography>}
                {values.Id && values.Shared &&
                    <Typography style={{fontSize: "16px"}}>
                        This profile is visible to all users at your company and all trading partners.
                    </Typography>}
                <Typography style={{fontSize: "16px"}}>
                    Are you sure you want to delete this profile?
                </Typography>
            </DialogContent>
            <DialogActions style={{padding: "24px"}}>
                <Button variant="text" disabled={disabled} onClick={onClose}>Cancel</Button>
                <Button variant="text" color="primary" disabled={disabled} onClick={() => props.deleteFnc()}>Yes</Button>
            </DialogActions>
        </Dialog>
    );
}
